import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
import { BusinessEntityService } from './business-entity.service';

@Injectable({
  providedIn: 'root'
})
export class LookupService {
  static setFilterData(_setFilterData: any) {
    throw new Error('Method not implemented.');
  }
  apiBaseUrl = 'http://localhost:3000';
  apiVersion = 'api/v1';
  serviceUrl = this.apiBaseUrl;
  contentType =  'application/json' // Sonar fix
  suppliermanagUrl:any="";
  static readonly getUnionFilters: any;
  
  constructor(private readonly http:HttpClient, private readonly bservice: BusinessEntityService,
    private readonly environment: EnvironmentConfiguration
    ) {
    this.apiBaseUrl = this.environment['apiUrl']?.lookupUrl;
    this.suppliermanagUrl = this.environment['apiUrl']?.suppliermanagUrl;
    this.serviceUrl = this.apiBaseUrl;
  }

  private readonly localStorageObservable = new BehaviorSubject<any>(null);
  localStorageData = this.localStorageObservable.asObservable();

  localStorageChanges(data: any) {
    if(data !== null){
      this.localStorageObservable.next(data);
    }
  }

  public inActiveSuppliersList(): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/inActiveSuppliersList`
    return this.http.get<any>(url,header);
  }

  public getSupplierListDetails(page, limit, employeeid): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/supplierList?page=${page}&limit=${limit}&empId=${employeeid}`
    return this.http.get<any>(url, header)
  }

  public getReportPeriod(): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/getReportPeriod`
    return this.http.get<any>(url, header)
  }  

  public getUnionFilters(): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/unionFilters`
    return this.http.get<any>(url, header)
  } 

  private readonly filterDataSubject = new BehaviorSubject<any>(null);

  setFilterData(data: any) {
    this.filterDataSubject.next(data);
  }

  getFilterData(): Observable<any> {
    return this.filterDataSubject.asObservable();
  }

  //Caching data for Emailer screen grid Table
  private emailerGridData: any[] | null = null;
  private currentReportPeriodValue: any = null;

  setEmailerGridData(data: any[], currentReportPeriod): void {
    this.emailerGridData = data;
    this.currentReportPeriodValue = currentReportPeriod
  }

  getEmailerGridData(): any[] | null {
    return this.emailerGridData;
  }

  getEmailerLatestReportPeriod() {
    return this.currentReportPeriodValue;
  }

  clearEmailerGridData(): void {
    this.emailerGridData = null;
  }

  public getReportHistoryDetails(page, limit, type, reportid, employeeid): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/reportData?page=${page}&limit=${limit}&type=${type}&reportId=${reportid}&empId=${employeeid}`
    return this.http.get<any>(url, header)
  }

  public getReportAllDetails(page, limit, type, employeeid): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/reportData?page=${page}&limit=${limit}&type=${type}&empId=${employeeid}`
    return this.http.get<any>(url, header)
  }

  public createReportPeriod(params): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.suppliermanagUrl+this.apiVersion}/createReportPeriod`
    return this.http.post<any>(url, params, header);
  }

  public getSuppliersForEmailer(reportPeriod, employeeid): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/getSuppliersForEmailer?reportPeriod=${reportPeriod}&empId=${employeeid}`
    return this.http.get<any>(url, header);
  }

  public getSavedEmail(reportPeriod, employeeid): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/getsavedEmail?reportPeriod=${reportPeriod}&employeeId=${employeeid}`;
    return this.http.get<any>(url, header);
  }

  saveEmailerContent(saveEmailerContentBody:any): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.suppliermanagUrl+this.apiVersion}/saveEmailerContent`;
    return this.http.post<any>(url, saveEmailerContentBody, header);
  }

  updateEmailerContent(saveEmailerContentBody:any): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.suppliermanagUrl+this.apiVersion}/updateEmailerContent`;
    return this.http.put<any>(url, saveEmailerContentBody, header);
  }

  sendEmail(saveEmailerContentBody): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.suppliermanagUrl+this.apiVersion}/sendEmail`;
    return this.http.post<any>(url, saveEmailerContentBody, header);
  }

  updatePathDetails(pathDetails){
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    }
    const url = `${this.suppliermanagUrl+this.apiVersion}/updateReportPeriodInfo`;
    return this.http.put<any>(url, pathDetails, header);
  }

  public getAssumeIdentityList(employeeId,role): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType,
      })
    } 
    const url = `${this.serviceUrl+this.apiVersion}/getAssumeIdentityList?employeeId=${employeeId}&role=${role}`;
    return this.http.get<any>(url, header);
  }
  
  getreportPeriodInfo(reportPeriod){
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType,
        // 'Authorization': `${this.bservice?.userToken}`
      })
    }
    const url = `${this.serviceUrl+this.apiVersion}/reportPeriodInfo?unionreportperiodid=${reportPeriod}`;
    return this.http.get<any>(url, header);
  }

  /** api to fetch user credentials */
  public getUserInfo(guid): Observable<any> {
    const httpCustomOptions = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType,
        'params': `{ "guid":"${guid}"}`
       })
    };
    const url = `${this.serviceUrl+this.apiVersion}/userInfo?guid=${guid}`;
    return this.http?.get<any>(url, httpCustomOptions)
  }

  downloadContractOrSignedContingencyFile(filePath): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType
      })
    };
    const url = `${this.serviceUrl+this.apiVersion}/downloadFile?filePath=${encodeURIComponent(filePath)}`;
    return this.http.get<any>(url, header);
  }
}